import { Button } from '@edsn/pie-components';
import Bolt from '@iconify/icons-material-symbols/bolt-outline';
import BreakingNewsIcon from '@iconify/icons-material-symbols/breaking-news-alt-1-outline';
import MoreHorizontalIcon from '@iconify/icons-material-symbols/more-horiz';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useUserHasRole } from '#pie/auth/useUserHasRole';
import { useStoredParams } from '#pie/stores/searchParams';
import { Card } from '../card/Card';
import { Divider } from '../divider/Divider';
import { Icon } from '../icon/Icon';
import { Stack } from '../stack/Stack';
import { Text } from '../text/Text';

export const TicketSelection = () => {
  const canCreateNonConformity = useUserHasRole({ marketRole: 'MV' });
  const params = useStoredParams('/berichtenbox');
  const { t } = useTranslation();
  const { t: transtic } = useTranslation('ticket');

  return (
    <Card className="max-w-4xl p-6">
      <Stack gap="lg">
        <div>
          <Text as="h2" variant="h5" className="text-content-heading">
            {transtic('create.ticket_type.title')}
          </Text>
        </div>
        <Stack gap="md">
          <Link to="ean">
            <div className="text-content-heading hover:outline-primary border-action-tertiary-enabled flex items-center gap-3 rounded-xs border py-3 pl-3 hover:bg-surface-disabled">
              <div className="rounded-full bg-surface-minimal-teal p-2">
                <Icon icon={Bolt} />
              </div>
              <Text
                as="h2"
                variant="base"
                className="text-content-heading font-bold"
              >
                {transtic('create.ticket_type.ean')}
              </Text>
            </div>
          </Link>
          <Link to="other">
            <div className="text-content-heading border border-action-tertiary-enabled flex items-center gap-3 rounded-xs py-3 pl-3 hover:bg-surface-disabled">
              <div className="rounded-full bg-surface-minimal-teal p-2">
                <Icon icon={MoreHorizontalIcon} />
              </div>
              <Text
                as="h2"
                variant="base"
                className="text-content-heading font-bold"
              >
                {transtic('create.ticket_type.other')}
              </Text>
            </div>
          </Link>
          {canCreateNonConformity && (
            <Link to="non-conformity">
              <div className="text-content-heading hover:outline-primary border-action-tertiary-enabled flex items-center gap-3 rounded-sms border py-3 pl-3 hover:bg-surface-disabled">
                <div className="rounded-full bg-surface-minimal-teal p-2">
                  <Icon icon={BreakingNewsIcon} />
                </div>
                <Text
                  as="h2"
                  variant="base"
                  className="text-content-heading font-bold"
                >
                  {transtic('create.ticket_type.non_conformity')}
                </Text>
              </div>
            </Link>
          )}
        </Stack>
        <Divider />
        <div>
          <Button
            as={Link}
            to={`/berichtenbox${params}`}
            action="tertiary"
            emphasis="subtle"
          >
            {t('common.button.cancel')}
          </Button>
        </div>
      </Stack>
    </Card>
  );
};
